import { FormControl } from "../Forms/FormControl";
import { FormModal } from "../Forms/FormModal";
import * as Yup from "yup";

export function WeightDifferencesForm({ onSubmit, defaultValues, isUpdate }) {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Nazwa jest wymagana").max(100, "Nazwa nie może mieć więcej niż 100 znaków"),
  });

  const formControls = (
    <>
      <FormControl label="Nazwa" name="name" autoFocus />
    </>
  );

  const buttonText = isUpdate ? "Edytuj różnicę" : "Dodaj różnicę";
  const successMessage = isUpdate ? "Zaktualizowano różnicę w wadze" : "Dodano różnicę w wadze";

  return (
    <FormModal
      formControls={formControls}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      buttonText={buttonText}
      successMessage={successMessage}
      title={buttonText}
      defaultValues={defaultValues}
      btnSize="small"
    />
  );
}
